import {
    IonList,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonModal,
    IonTitle,
    IonContent,
    IonSearchbar,
    IonLabel,
    IonItem,
} from "@ionic/react";
import React, { useState, useEffect } from "react";
import { GangMember } from "../models/GangMember";

interface AddPermitGangMemberModalProps {
    isOpen: boolean;
    onClose: (gangMember?: GangMember) => void;
    gangMembers: GangMember[];
}

const AddPermitGangMemberModal: React.FC<AddPermitGangMemberModalProps> = ({ isOpen, onClose, gangMembers }) => {
    const [filteredGangMembers, setFilteredGangMembers] = useState([] as GangMember[]);

    useEffect(() => {
        setFilteredGangMembers([...gangMembers]);
    }, [gangMembers]);

    const handleInput = (event: Event) => {
        let query = "";
        const target = event.target as HTMLIonSearchbarElement;
        if (target) query = target.value!.toLowerCase();

        if (gangMembers) {
            setFilteredGangMembers(
                gangMembers.filter(
                    (b) =>
                        b.firstName.toLowerCase().includes(query) ||
                        b.lastName.toLowerCase().includes(query) ||
                        b.inductionNumber?.toLowerCase().includes(query)
                )
            );
        }
    };

    const renderList = (list: GangMember[]) => {
        const sortedList = sortGangMembersAlphabetically(list);
        return <IonList>{sortedList.map(renderListItem)}</IonList>;
    };

    const renderListItem = (gangMember: GangMember) => {
        return (
            <IonItem key={gangMember.id} onClick={(event: any) => onClose(gangMember)}>
                <IonLabel>
                    <h2>{gangMember.firstName}</h2>
                    <h3>{gangMember.lastName}</h3>
                    <p>{gangMember.inductionNumber}</p>
                </IonLabel>
            </IonItem>
        );
    };

    return (
        <IonModal isOpen={isOpen} onDidDismiss={(event: any) => onClose()}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Add Gang Member</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={(event: any) => onClose()} strong>
                            Close
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>

            <IonContent class="outer-content">
                <IonSearchbar debounce={1000} onIonInput={(e) => handleInput(e)}></IonSearchbar>
                {renderList(filteredGangMembers)}
            </IonContent>
        </IonModal>
    );
};

function sortGangMembersAlphabetically(gangMembers: GangMember[]): GangMember[] {
    return [...gangMembers].sort((a, b) => {
        // First compare last names:
        const lastCmp = a.lastName.localeCompare(b.lastName, undefined, { sensitivity: "base" });
        if (lastCmp !== 0) return lastCmp;
        // If last names are equal, compare first names:
        return a.firstName.localeCompare(b.firstName, undefined, { sensitivity: "base" });
    });
}

export default AddPermitGangMemberModal;
